import React, { Fragment, useContext, useState , useEffect} from 'react';
import PropTypes from 'prop-types';
import ModalPop from '../modal/modal';
import localization from 'assets/localization/localization';
import Images from 'assets/images/imageData';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Loader from 'components/sales/Loader/loader';


const CsvFileUpload = ({
  handleModalHide = null,
  isCsvModal,
  isUploaded = false,
  setIsuploaded,
  sampleData = null,
  setCsvModal,
  redirectUrl = '/dashboard',
  redirectName = localization.upload,
  setCsvUploadUrl,
  handleCsvSubmit,
  uploadResponse,
  setUploadResponse,
  isLoading = false,
  
}) => {
  const { baseUrl } = useContext(BaseUrl);

  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState('');
  const [progress, setProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

const handleCsvModalHide = () => {
    setCsvModal(false);
    setSelectedFile(null);
    setProgress(0);
    setIsUploading(false);
    setCsvUploadUrl("");
    setSelectedFile(null);
    setError('');
    setIsuploaded(false);

    // window.location.reload();
  };
  const handleFileChange = (file) => {
    if (!file) return;
    if (file.type !== 'text/csv' && !file.name.endsWith('.csv')) {
      setError('Only CSV files are allowed!');
      setSelectedFile(null);
      setCsvUploadUrl(null);
      return;
    }
    setError('');
    setSelectedFile(file);
    setCsvUploadUrl({ val: file });
  };

  const onSubmit = () => {
    if (!selectedFile) {
      setError('Please select a CSV file before submitting.');
      return;
    }

    setIsUploading(true);
    setProgress(0);

    // Fake progress simulation
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev < 96) return prev + 4;
        return prev;
      });
    }, 200);
    handleCsvSubmit();
  };

  return (
    <Fragment>
      <ModalPop
        title={localization.upload + " File"}
        show={isCsvModal}
        handleModalHide={handleCsvModalHide}
        keyboard
        backdrop
      >
        <div className="bulk_upload text-center">
          {isUploaded ? (
            
            <Fragment>
              {isUploaded && uploadResponse?.inserted?.length > 0 ? ( 
                <div>
              <div className="success">
                <img src={Images?.tick} alt="Success" />
              </div>
              <p>Uploaded successfully. Re-assignment will take 15 minutes.</p>
              {/* <Link
                to={`${baseUrl}${redirectUrl}`}
                className="btn btn-primary mb-4"
                onClick={handleModalHide}
              >
                {redirectName} <img src={Images?.ArrowRight} alt="Arrow" />
              </Link> */}
              </div>
              ) : (
                <div>
                  <p className="text-red-600 mb-4">
                    Upload failed or no records were inserted.
                  </p>
                </div>
              )}
              {uploadResponse?.failed_csv_url && (
                <a
                  className="btn btn-danger mb-6 text-center"
                  href={uploadResponse.failed_csv_url}
                  download
                >
                  Download Failed Insertions
                </a>
              )}
              {uploadResponse?.skipped_count > 0 && (
                  <p className="text-sm text-gray-700 mt-2">
                      {uploadResponse?.inserted?.length || 0} record(s) inserted and {uploadResponse?.skipped_count || 0} record(s) not uploaded.
                  </p>
                )}
              
            </Fragment>
          ) : (
            <div style={{ margin: '4px' }}>
              <label className="btn btn-secondary w-auto mt-2">
                Choose File
                <input
                  type="file"
                  accept=".csv"
                  style={{ display: 'none' }}
                  onChange={(e) => handleFileChange(e.target.files[0])}
                />
              </label>

              {selectedFile && (
                <p className="mt-2">Selected File: {selectedFile.name}</p>
              )}

              {error && <p className="text-danger mt-2">{error}</p>}

              {isUploading && (
                <div
                  style={{
                    width: '100%',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    marginTop: '15px',
                  }}
                >
                  <div
                    style={{
                      width: `${progress}%`,
                      background: '#4caf50',
                      color: 'white',
                      textAlign: 'center',
                      padding: '4px 0',
                      borderRadius: '4px',
                      transition: 'width 0.3s ease',
                    }}
                  >
                    {progress}%
                  </div>
                </div>
              )}
              <br />
              {selectedFile && (
             <center><div className="d-flex justify-content-center gap-2 mt-3">
              <button
                className="btn btn-lg btn-primary"
                onClick={onSubmit}
                disabled={!selectedFile || error}
              >
                {localization.submit}
              </button></div></center>
              )}

              {/* {sampleData?.file_url && (
                <a
                  className="btn btn-primary w-auto ml-2"
                  href={sampleData.file_url}
                  download="sample_csv_file.csv"
                >
                  Download Sample CSV
                </a>
              )} */}
            
            </div>
          )}
        </div>
      </ModalPop>
    </Fragment>
  );
};

CsvFileUpload.propTypes = {
  handleModalHide: PropTypes.func,
  isCsvModal: PropTypes.bool,
  isUploaded: PropTypes.bool,
  sampleData: PropTypes.object,
  setCsvModal: PropTypes.func.isRequired,
  setisuploaded: PropTypes.func.isRequired,
  setCsvUploadUrl: PropTypes.func.isRequired,
  handleCsvSubmit: PropTypes.func.isRequired,
  uploadResponse: PropTypes.object,
};

export default CsvFileUpload;
